























































































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { P, X, C, getTxChainType } from '@/known_blockchains'
import {
    DEFAULT_NETWORK_ID,
    cChainExplorerURL,
    cChainExplorerURL_test,
} from '@/store/modules/network/network'

@Component({
    components: {},
})
export default class RecentTxHeader extends Vue {
    @Prop() heading!: string
    @Prop() loading!: boolean

    updateTx() {
        this.$emit('update')
    }

    get xChain() {
        return getTxChainType(X.id)
    }

    get pChain() {
        return getTxChainType(P.id)
    }

    get cChain() {
        return getTxChainType(C.id)
    }

    get cChainURL() {
        return DEFAULT_NETWORK_ID === 1
            ? cChainExplorerURL
            : cChainExplorerURL_test
    }

    goToTx() {
        this.$router.push('/tx')
    }
}
